/* unplugin-vue-components disabled */import { render } from "./login-layout.vue?vue&type=template&id=5dc58739&scoped=true"
const script = {}

import "./login-layout.vue?vue&type=style&index=0&id=5dc58739&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc58739"]])

export default __exports__